import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';

import Room from './Room';

import './RoomsManager.css';

const RoomsManager = (props) => {
  const {
    reservationId,
    roomsList,
    availableRoomsList,
    availableMealPlansList,
    hasToValidate,
    readOnly
  } = props;

  const handleRoomCode = (roomId, roomCode) => {
    props.handleRoomType(reservationId, roomId, roomCode);
  };

  const handleRoomMealPlan = (roomId, mealPlan) => {
    props.handleMealPlan(reservationId, roomId, mealPlan);
  };

  const handleRoomDistribution = (roomId, distributionData) => {
    props.handleRoomDistribution(reservationId, roomId, distributionData);
  };

  const deleteExistingRoom = (roomId) => {
    props.handleRemoveRoom(reservationId, roomId);
  };

  const canRemoveRooms = (roomsList.length > 1);

  return (
    <Container>
      {
        roomsList.map(room => (
          <Room
            key={room.id}
            room={room}
            canBeRemoved={canRemoveRooms}
            availableRoomsList={availableRoomsList}
            availableMealPlansList={availableMealPlansList}
            readOnly={readOnly}
            hasToValidate={hasToValidate}
            handleRoomCode={handleRoomCode}
            handleMealPlan={handleRoomMealPlan}
            handleDistribution={handleRoomDistribution}
            handleEraseRoom={deleteExistingRoom}
          />
        ))
      }
    </Container>
  );
};

RoomsManager.propTypes = {
  reservationId: PropTypes.number.isRequired,
  roomsList: PropTypes.arrayOf(PropTypes.object),
  availableRoomsList: PropTypes.arrayOf(PropTypes.object),
  availableMealPlansList: PropTypes.arrayOf(PropTypes.object),
  readOnly: PropTypes.bool,
  hasToValidate: PropTypes.bool,
  handleRoomType: PropTypes.func,
  handleMealPlan: PropTypes.func,
  handleRoomDistribution: PropTypes.func,
  handleRemoveRoom: PropTypes.func
};

RoomsManager.defaultProps = {
  roomsList: [],
  availableRoomsList: [],
  availableMealPlansList: [],
  readOnly: false,
  hasToValidate: false,
  handleRoomType: () => {},
  handleMealPlan: () => {},
  handleRoomDistribution: () => {},
  handleRemoveRoom: () => {}
};

export default React.memo(RoomsManager);
